import { Button, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import ProgressBar from "react-customizable-progressbar";
import { RWebShare } from "react-web-share";
import ImageLoader from "../../../components/imageLoader";
import { apiCall } from "../../../utils/helpers";

import FB from "../../../assets/images/fb.svg";
import INSTA from "../../../assets/images/insta.svg";
import LINKEDIN from "../../../assets/images/linkedin.svg";
import TWITTER from "../../../assets/images/twitter.svg";

export default function DownloadApp({
  data,
  onBoardingUser = {},
  setOnboardingUser = () => {},
  step = 1,
  selectedSubTypes = [],
  setStep = () => {},
  scorePercentage = 0,
  score = 0,
  tag = "",
  setTag = () => {},
}) {
  const [loading, setLoading] = React.useState(false);
  const ismobile = window.innerWidth <= 768;

  const [waitlistCount, setWaitListCount] = React.useState(0);

  const socialIcons = [
    {
      icon: FB,
      link: `https://www.facebook.com/sharer/sharer.php?u=https%3A//dopamine.fit/?source=facebook%26medium=web%26user=${data?.user_id}`,
    },
    {
      icon: INSTA,
      link: "#",
    },
    {
      icon: TWITTER,
      link: `https://twitter.com/intent/tweet?text=https%3A//dopamine.fit/?source=twitter%26medium=web%26user=${data?.user_id}`,
    },
    {
      icon: LINKEDIN,
      link: `https://www.linkedin.com/shareArticle?mini=true&url=https%3A//dopamine.fit/?source=linkedin%26medium=web%26user=${data?.user_id}`,
    },
  ];

  const getWishlistCount = () => {
    setLoading(true);
    apiCall
      .post("v1/dopamine/getWaitlistCount", {
        api_name: "getWaitlistCount",
        user_id: onBoardingUser?.user_id,
        key: "JWT",
        secret: "DOPAMINE",
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.success) {
          const waitlist_count = res.data.data.waitlist_count;
          setWaitListCount(waitlist_count);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getWishlistCount();
  }, []);

  const getCustomerDataHandler = () => {
    setLoading(true);
    apiCall
      .post("v1/dopamine/getCustomerById", {
        api_name: "getCustomerById",
        //   key: "JWT",
        //   secret: "DOPAMINE",
        auth: onBoardingUser?.token,
        user_id: onBoardingUser?.user_id,
      })
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.success) {
          setOnboardingUser(res?.data?.data);
          if (
            res?.data?.data?.health_score >= 50 &&
            res?.data?.data?.health_score <= 250
          ) {
            setTag("worst");
          } else if (
            res?.data?.data?.health_score >= 300 &&
            res?.data?.data?.health_score <= 500
          ) {
            setTag("bad");
          } else if (res?.data?.data?.health_score === 500) {
            setTag("neutral");
          } else if (
            res?.data?.data?.health_score >= 550 &&
            res?.data?.data?.health_score <= 700
          ) {
            setTag("good");
          } else if (
            res?.data?.data?.health_score >= 750 &&
            res?.data?.data?.health_score <= 950
          ) {
            setTag("great");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  React.useEffect(() => getCustomerDataHandler(), []);

  return (
    <>
      {loading ? (
        <div style={{ textAlign: "center", margin: "auto" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div
            className="onboarding-step onboarding-step-8"
            style={{ padding: "1rem", overflowY: "hidden" }}
          >
            <div className="download-screen-top">
              {/* <Image src={PLACEHOLDER} width={110} duration={200} />
              <p className="name">
                {onBoardingUser?.first_name} {onBoardingUser?.last_name}
              </p>
              <div className="interest-list">
                {onBoardingUser?.category?.map((interest, i) => (
                  <div key={i} className="interest-list-item">
                    {interest?.category_name}
                  </div>
                ))}
              </div> */}
              <div className="progressbar-col" style={{ width: "100%" }}>
                <ProgressBar
                  radius={50}
                  progress={scorePercentage || onBoardingUser?.percentage}
                  strokeWidth={8}
                  strokeColor={
                    tag === "worst"
                      ? "#FF0000"
                      : tag === "bad"
                      ? "#FF9635"
                      : tag === "good"
                      ? "#8FBF07"
                      : tag === "great"
                      ? "#00BE2A"
                      : "#EEEEEE"
                  }
                  trackStrokeWidth={8}
                  pointerRadius={5}
                  pointerStrokeWidth={5}
                  pointerStrokeColor={
                    tag === "worst"
                      ? "#FF0000"
                      : tag === "bad"
                      ? "#FF9635"
                      : tag === "good"
                      ? "#8FBF07"
                      : tag === "great"
                      ? "#00BE2A"
                      : "#EEEEEE"
                  }
                  cut={80}
                  rotate={-230}
                >
                  <div className="indicator">
                    <div>
                      <p
                        className="score"
                        style={{
                          color: "#FFFFFF",
                          position: "absolute",
                          fontWeight: 700,
                          fontSize: 28,
                          top: 15,
                          bottom: 0,
                          left: 0,
                          right: 0,
                        }}
                      >
                        {score || onBoardingUser?.health_score || "--"}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: 11,
                          fontWeight: 500,
                          color: "#6F7379",
                          position: "absolute",
                          top: 80,
                          bottom: 0,
                          left: 0,
                          right: 0,
                        }}
                      >
                        Your health score
                        <p
                          style={{
                            width: "100%",
                            margin: 0,
                            fontWeight: 500,
                            fontSize: 15,
                            textTransform: "capitalize",
                            color:
                              tag === "worst"
                                ? "#ff0000"
                                : tag === "bad"
                                ? "#ff9635"
                                : tag === "good"
                                ? "#8fbf07"
                                : "#00be2a",
                          }}
                        >
                          {tag}
                        </p>
                      </p>

                      {/* <div
                        // className={`tag tag-${tag}`}
                        style={{
                          background:
                            tag === "worst"
                              ? "#ff0000"
                              : tag === "bad"
                              ? "#ff9635"
                              : tag === "good"
                              ? "#8fbf07"
                              : "#00be2a",
                          textAlign: "center",

                          position: "absolute",
                          // width: 38,
                          // height: 17,
                          padding: 0,
                          top: "65%",
                          bottom: 0,
                          left: "46%",
                          right: 0,
                        }}
                      >
                        <p style={{ margin: 0 }}> {tag}</p>
                      </div> */}
                    </div>
                  </div>
                </ProgressBar>
              </div>
              {tag !== "" && (
                <p
                  className="score-para"
                  style={{
                    color: "#FFFFFF",
                    fontSize: ismobile ? 15 : 20,
                    margin: 0,
                  }}
                >
                  {/* {onBoardingUser?.first_name}, you’re doing {tag}, <br/>all the best */}
                  {(() => {
                    switch (tag) {
                      case "worst":
                        return (
                          <>
                            Hey, <b>{onBoardingUser?.first_name}</b>, You need
                            to get moving on your health!
                          </>
                        );
                      case "bad":
                        return (
                          <>
                            Hey, <b>{onBoardingUser?.first_name}</b>, Your
                            health is in a really bad shape, we recommend you to
                            connect with an expert immediately!
                          </>
                        );
                      case "neutral":
                        return (
                          <>
                            Hey, <b>{onBoardingUser?.first_name}</b>, You need
                            some improvement on your health, lets start with
                            daily exercise & healthy food?
                          </>
                        );
                      case "good":
                        return (
                          <>
                            Hey, <b>{onBoardingUser?.first_name}</b>, You're
                            doing good! Let's keep pushing for a better you!
                          </>
                        );
                      case "great":
                        return (
                          <>
                            Hey, <b>{onBoardingUser?.first_name}</b>, Seems like
                            you're in the best shape of your life! Why don't you
                            be an expert and guide others?
                          </>
                        );
                      default:
                        return null;
                    }
                  })()}
                </p>
              )}
            </div>

            {/* <div
            style={{
              background:
                "linear-gradient(180deg, rgba(223, 224, 226, 0) 0%, #DFE0E2 50%, rgba(223, 224, 226, 0) 100%)",
              padding: 1,
            }}
          > */}
            {/* <hr className="divider" /> */}
            {/* </div> */}
          </div>

          {/* <div
          // className="onboarding-step onboarding-step-8"
          // style={{ padding: "1rem", overflowY: "hidden" }}
          > */}
          <div
            style={{
              paddingTop: 1,
              height: "50%",

              margin: "30px -1rem 0px -1rem",
              background:
                "linear-gradient(116.26deg, rgba(255, 255, 255, 0) 6.96%, #FFFFFF 35.22%, rgba(255, 255, 255, 0) 63.48%)",
            }}
          >
            <div
              className="download-screen-bottom"
              style={{
                paddingTop: 36,
              }}
            >
              <div className="waitlist-top-section" style={{ height: "80%" }}>
                {
                  // waitlistData?.admin_type_id === 1 &&
                  <>
                    {/* <div className="logo-div">
                        <ImageLoader
                          src={
                            DOPELOGO
                            // waitlistData?.admin_type_id === 1
                            //   ? BUSINESSCARD
                            //   : waitlistData?.admin_type_id === 2
                            //   ? BUSINESSCARDBRAND
                            //   : BUSINESSCARDCENTRE
                          }
                          style={{
                            objectFit: "contain",
                            width: "176px",
                            height: "195px",
                            // marginBottom: ismobile ? "-70px" : "-10px",

                            // // marginTop: "10%",
                            // height: "227px",
                          }}
                        />
                      </div> */}
                    <div
                      style={{
                        textAlign: "center",
                        color: "#FFFFFF",
                        // marginBottom: ismobile ? 0 : 50,
                      }}
                    >
                      <p
                        className="white-line"
                        style={{
                          margin: 0,
                        }}
                      >
                        You’re on the waitlist
                      </p>
                      <p
                        className="queue-number"
                        style={{
                          color: "#FF4A01",
                          fontSize: 40,
                          fontWeight: 600,
                          margin: 0,
                        }}
                      >
                        {waitlistCount === 0 ? "--" : waitlistCount}
                      </p>
                      <p
                        className="grey-line"
                        style={{ margin: 0, color: "#C8C8C8", fontSize: 16 }}
                      >
                        Your position in queue
                      </p>
                    </div>

                    <div
                      style={{
                        padding: ismobile
                          ? "0px 25px 25px 25px"
                          : "0px 25px 30px 25px",
                      }}
                    >
                      <div
                        // className="waitlist-bottom-section"
                        style={{
                          color: "#FFFFFF",
                          borderRadius: "11.6279px",
                          paddingTop: 0,

                          // paddingTop: data?.admin_type_id !== 1 && ismobile ? 160 : null,
                        }}
                      >
                        <div className="early-access-div">
                          <div className="text-div">
                            <p className="white-line">
                              Want to get early access?
                            </p>
                            <p className="grey-line">
                              Ask for an exclusive invite from existing user of
                              Dopamine.fit
                            </p>
                          </div>
                          <div className="social-icon-div">
                            {socialIcons.map((icon, i) => (
                              <IconButton
                                style={{ marginRight: 8 }}
                                key={i}
                                onClick={() => window.open(icon.link)}
                              >
                                <ImageLoader
                                  src={icon.icon}
                                  style={{ objectFit: "contain" }}
                                />
                              </IconButton>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>

              {/* <div className="download-div">
              <div className="text-col">
                <p className="para">
                  Download app now to complete your profile
                </p>
                <p
                  className="link"
                  onClick={() =>
                    (document.location.href = "https://onelink.to/5z9d3p")
                  }
                >
                  Download now
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 16L22 16"
                      stroke="#222831"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 10L23 16L17 22"
                      stroke="#222831"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <div className="img-col">
                <Image src={FINALSCREENICON} width={80} duration={200} />
              </div>
            </div> */}

              <div
                // className="request-footer-btn"
                style={{
                  padding: "0px 45px 20px",
                  border: "none",
                }}
              >
                <RWebShare
                  // data={{ text: "Hey, check out this cool app!", title: "Checkout this cool app!", url: `https://dopamine.fit/?source=whatsapp&medium=web&user=${onBoardingUser?.user_id}` }}
                  data={{
                    text: "Hey, check out this cool app!",
                    title: "Checkout this cool app!",
                    url: `https://dopamine.fit/`,
                  }}
                  onClick={() => {}}
                >
                  <Button
                    id="step-8-request-invite"
                    style={{
                      padding: "16px 0",
                      fontSize: "1em",
                      background:
                        "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
                      color: "#FF4A01",
                    }}
                    fullWidth
                    variant="contained"
                    size="large"
                    disabled={loading}
                  >
                    Request an invite
                  </Button>
                </RWebShare>
                {/* <div
                    className="early-access-div"
                    style={{
                      textAlign: "center",
                      color: "#FFFFFF",
                      marginTop: 20,
                    }}
                  >
                    <div className="text-div">
                      <p
                        className="white-line"
                        style={{ margin: "0px 0px 10px 0px" }}
                      >
                        Want to get early access?
                      </p>
                      <p
                        className="grey-line"
                        style={{ margin: 0, color: "#C8C8C8" }}
                      >
                        Ask for an exclusive invite from existing user of
                        Dopamine.fit
                      </p>
                    </div>
                  </div> */}
              </div>
            </div>
          </div>
          {/* </div> */}
        </>
      )}
    </>
  );
}
